export enum FollowUpStatus {
  Prospect,
  FollowedUp,
  DeclinedMembership,
  ConsideringMembership,
}

/** Normalize status from API (string or number) to FollowUpStatus enum. */
export function parseFollowUpStatus(value: unknown): FollowUpStatus {
  if (typeof value === "number" && value in FollowUpStatus) return value as FollowUpStatus;
  if (typeof value === "string") {
    const key = value as keyof typeof FollowUpStatus;
    if (key in FollowUpStatus && typeof FollowUpStatus[key] === "number") {
      return FollowUpStatus[key] as FollowUpStatus;
    }
  }
  return FollowUpStatus.Prospect;
}

export interface MemberFollowup {
  id?: number;
  membershipId: string;
  notes: string;
  followUpDate: string;
  nextFollowUpDate?: string;
  status: FollowUpStatus;
  clientName?: string;
  createdAt?: string;
  updatedAt?: string;
  /** Staff user who last spoke to the member (attribution). */
  contactedByStaffId?: number | null;
  /** Resolved staff name for display; set by the API on read. */
  contactedByStaffName?: string;
}